<template>
	<div class="modal fade" :id="'notificationModal-'+index" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">Notifications</h1>
					<button type="button" class="close" data-dismiss="modal" aria-label="close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div v-for="(n,index) in notifications" :key='index'>
						<h3>
							{{n.name}}
						</h3>
						<p v-html="n.message"></p>
						<hr/>
					</div>
					<div class="row">
						<div class="col-12">
							<button class="btn btn-primary w-100" v-on:click.prevent="close_modal">I Understand</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	const $ = window.$
	
	export default {
		name: 'NotificationModal',
		props: ['notifications', 'index'],
		components: {},
		computed: {},
		methods: {
			close_modal() {
				$('#notificationModal-' + this.index).modal('hide');
			}
		}
	};
</script>
